import { User } from '../models/User';
import { Post } from '../models/Post';

export const MOCK_USER: User = {
  cognitoUserId: 'demo-user-id',
  firstName: 'Demo',
  lastName: 'User',
  email: 'demo@example.com',
  cellNumber: '555-0123',
  birthday: '1990-01-01',
  streetAddress: '123 Family Way',
  city: 'Greenwich',
  stateText: 'CT',
  zipCode: '06830',
  darkMode: true, // Default to true for consistent testing
  postCollege: true,
  advisor: false,
};

export const MOCK_USERS: User[] = [
  MOCK_USER,
  {
    cognitoUserId: 'jane-doe',
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'jane@example.com',
    cellNumber: '555-9876',
    birthday: '1985-05-15',
    streetAddress: '456 Heritage Ln',
    city: 'New Canaan',
    stateText: 'CT',
    zipCode: '06840',
    darkMode: true,
    postCollege: false,
    advisor: true,
  }
];

export const MOCK_COMMENTS: any[] = [
  {
    id: 'c1',
    postId: '1',
    createdAtEpochMilli: Date.now() - 1800000,
    content: 'This is a great update! Thanks for sharing.',
    commentCognitoUserId: 'jane-doe',
    likeCount: 2,
  },
  {
    id: 'c2',
    postId: '1',
    createdAtEpochMilli: Date.now() - 900000,
    content: 'Glad to be part of this family.',
    commentCognitoUserId: 'demo-user-id',
    likeCount: 0,
  }
];

export const MOCK_POSTS: Post[] = [
  {
    id: '1',
    createdAtEpochMilli: Date.now() - 3600000,
    content: 'Welcome to the new Mitchell Family Council portal! Check out the documents section for the latest updates.',
    posterCognitoUserId: 'demo-user-id',
    likeCount: 5,
    commentCount: 2,
    isLikedByCurrentUser: true,
    recentComments: MOCK_COMMENTS.slice(0, 2)
  },
  {
    id: '2',
    createdAtEpochMilli: Date.now() - 86400000,
    content: 'Had a great time at the family gathering last weekend!',
    posterCognitoUserId: 'jane-doe',
    likeCount: 12,
    commentCount: 0,
    isLikedByCurrentUser: false,
    recentComments: []
  }
];

// Mock AWS Clients
export class MockDynamoDBClient {
  async send(command: any) {
    const commandName = command.constructor.name;
    const input = command.input;

    if (commandName === 'ScanCommand') {
      return {
        Items: MOCK_USERS.map(u => this.marshall(u)),
        LastEvaluatedKey: undefined
      };
    }
    if (commandName === 'QueryCommand') {
      // Check if it's a comment query
      const pk = input.ExpressionAttributeValues?.[':pk']?.S;
      const skPrefix = input.ExpressionAttributeValues?.[':skPrefix']?.S;

      if (skPrefix === 'COMMENT#') {
        const postId = pk?.replace('POST#', '');
        const comments = MOCK_COMMENTS.filter(c => c.postId === postId);
        return {
          Items: comments.map(c => this.marshall({
            ...c,
            PK: pk,
            SK: `COMMENT#${c.createdAtEpochMilli}#${c.id}`
          }))
        };
      }

      // Default to posts if it's a feed query
      if (input.IndexName === 'GSI1' || input.IndexName === 'GSI2') {
        return {
          Items: MOCK_POSTS.map(p => this.marshall(p))
        };
      }

      // Single post metadata query
      if (pk && input.ExpressionAttributeValues?.[':sk']?.S === 'METADATA') {
        const postId = pk.replace('POST#', '');
        const post = MOCK_POSTS.find(p => p.id === postId);
        return {
          Items: post ? [this.marshall(post)] : []
        };
      }

      return {
        Items: MOCK_POSTS.map(p => this.marshall(p))
      };
    }
    if (commandName === 'PutItemCommand' || commandName === 'UpdateItemCommand' || commandName === 'DeleteItemCommand' || commandName === 'BatchGetItemCommand') {
      return {
        Responses: {
          'MitchellFC_Feed': []
        }
      };
    }
    return {};
  }

  // Simple marshalling for the UI's unmarshall calls
  private marshall(obj: any) {
    const marshalled: any = {};
    for (const key in obj) {
      marshalled[key] = { S: String(obj[key]) };
      if (typeof obj[key] === 'boolean') marshalled[key] = { BOOL: obj[key] };
      if (typeof obj[key] === 'number') marshalled[key] = { N: String(obj[key]) };
    }
    return marshalled;
  }
}

export class MockS3Client {
  async send() {
    return {
      Contents: [],
      CommonPrefixes: []
    };
  }
}

export class MockLambdaClient {
  async send() {
    return {
      Payload: new TextEncoder().encode(JSON.stringify({ statusCode: 200, body: JSON.stringify([]) }))
    };
  }
}
